import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AppIntroduction from './pages/AppIntroduction';
import TermsAndPrivacy_v1_0_0 from './pages/TermsAndPrivacy_v1_0_0';
import TermsAndPrivacy_v1_0_1 from './pages/TermsAndPrivacy_v1_0_1';
import TermsAndPrivacy_v1_0_2 from './pages/TermsAndPrivacy_v1_0_2';
import NotFound from './pages/NotFound';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Navigate to="/app_introduction" replace />} />
        <Route path="/app_introduction" element={<AppIntroduction />} />
        <Route path="/terms_and_privacy_1.0.0" element={<TermsAndPrivacy_v1_0_0 />} />
        <Route path="/terms_and_privacy_1.0.1" element={<TermsAndPrivacy_v1_0_1 />} />
        <Route path="/terms_and_privacy_1.0.2" element={<TermsAndPrivacy_v1_0_2 />} />
        <Route path="/terms_and_privacy" element={<Navigate to="/terms_and_privacy_1.0.2" replace />} />
        <Route path="/terms_and_privacy/" element={<Navigate to="/terms_and_privacy_1.0.2" replace />} />
        <Route path="/terms_and_privacy.html" element={<Navigate to="/terms_and_privacy_1.0.2" replace />} />
        <Route path="/terms_and_privacy/terms_and_privacy.html" element={<Navigate to="/terms_and_privacy_1.0.2" replace />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}

export default App;